import {onError} from '@apollo/client/link/error';
import {exceptionCaughtAction} from '../application/exceptions';
import {store} from '../../member/store';

export const errorLink = onError(err => {
  store.dispatch(exceptionCaughtAction(err.networkError));
});
